export default "__VITE_ASSET__CeOdEmOT__"